<template>
  <el-form ref="form" :model="formData" label-position="top" :rules="rules">
    <div v-show="isAdd">
      <el-row>
        <el-form-item label="로그 아이디" prop="applogId" label-width="120px"><el-input placeholder="아이디를 입력하세요" v-model="formData.applogId"></el-input></el-form-item>
      </el-row>
    </div>
    <el-row>
      <el-form-item label="로그 경로" prop="applogDir" label-width="120px"><el-input placeholder="경로를 입력하세요" v-model="formData.applogDir"></el-input></el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="로그 파일형태" label-width="120px">
        <el-radio-group v-model="formData.patternFlag" @change="selectPattern" :disabled="!isAdd">
          <el-radio label="N">고정형 로그파일</el-radio>
          <el-radio label="Y">패턴형 로그파일</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="로그 파일명" label-width="120px" prop="applogFile" v-show="(formData.patternFlag === 'N')">
        <span>
          <el-input placeholder="파일명을 입력하세요" v-model="formData.applogFile" :disabled="formData.applogFileAttrib === 'D'"></el-input>
        </span>
      </el-form-item>
      <el-form-item label="로그 파일명" label-width="120px" prop="applogPatternFile" v-show="(formData.patternFlag === 'Y')">
        <span>
          <el-row type="flex">
            <el-input class="mr-r4" placeholder="패턴 앞" v-model="formData.beforePattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
            <el-input class="mr-r4" placeholder="패턴(예:YYYYMMDD)" v-model="formData.pattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
            <el-input placeholder="패턴 뒤" v-model="formData.afterPattern" :disabled="formData.applogFileAttrib === 'D'"></el-input>
          </el-row>
        </span>
      </el-form-item>
    </el-row>
    <el-row :getter="20">
      <el-col :span="12">
        <el-form-item label="삭제 수행" label-width="120px">
          <el-switch v-model="formData.applogRawDelFlag" active-value="1" inactive-value="0" @change="changeDelFlag"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="삭제 주기" label-width="120px">
          <el-select v-model="formData.applogRawDelInteval" :disabled ="!checkDelFlag()" placeholder="일간" class="LogSettingSearchSelect" style="width:100%">
            <el-option v-for="(item, index) in deleteTimeList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-form-item label="정렬 순서" label-width="120px">
        <el-input-number placeholder="정렬순서를 입력하세요" v-model="formData.orderbyIndex" controls-position="right" :min="1" :max="9999"></el-input-number>
      </el-form-item>
    </el-row>
    <el-row>
      <el-form-item label="로그 설명" label-width="120px" prop="applogDesc">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="로그 설명을 입력하세요"
          v-model="formData.applogDesc"></el-input>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import applogAPI from '@/api/settings/log/lms-applog-setting';

export default {
  name: 'WApplogBasicSetting',
  props: {
    serverId: Number,
    isAdd: {
      type: Boolean,
    },
    formData: {
      type: Object,
    },
  },
  data() {
    const validateApplogId = (rule, value, callback) => {
      const params = {
        params: {
          serverId: this.serverId,
          applogId: value,
        },
      };
      const pattern = /[ㄱ-ㅎㅏ-ㅣ가-힣\W]/;
      if (pattern.test(value) === true) {
        callback(new Error('정책 명은 영문 입력입니다.'));
      }
      applogAPI.checkApplogId(params).then((response) => {
        if (isNil(value) || value.length === 0) {
          callback(new Error('필수 정보입니다.'));
        } else if (!isEmpty(value) && value.length > 64) {
          callback(new Error(msgUtil.getStringLengthValidationMsgData(64)));
        } else if (this.isAdd && response.data.success && !response.data.data) {
          callback(new Error('이미 존재하는 로그 아이디입니다.'));
        } else if (this.isAdd && !response.data.success) {
          callback(new Error('로그 아이디의 중복 여부를 확인하지 못하였습니다.'));
        } else {
          callback();
        }
      }).catch(() => {
        callback(new Error('로그 아이디의 중복 여부를 확인하지 못하였습니다.'));
      });
    };
    const validateApplogDir = (rule, value, callback) => {
      if (!isEmpty(value) && value.length > 255) {
        callback(new Error(msgUtil.getStringLengthValidationMsgData(255)));
      } else {
        callback();
      }
    };
    const validateApplogFile = (rule, value, callback) => {
      if (this.formData.patternFlag === 'N' && !isEmpty(value) && value.length > 255) {
        callback(new Error(msgUtil.getStringLengthValidationMsgData(255)));
      } else {
        callback();
      }
    };
    const validatePatternFile = (rule, value, callback) => {
      const beforePat = this.formData.beforePattern;
      const pat = this.formData.pattern;
      const afterPat = this.formData.afterPattern;
      if (this.formData.patternFlag === 'Y' && ((!isEmpty(beforePat) && beforePat.length > 64) || (!isEmpty(pat) && pat.length > 64) || (!isEmpty(afterPat) && afterPat.length > 64))) {
        callback(new Error(msgUtil.getStringLengthValidationMsgData(64)));
      } else {
        callback();
      }
    };
    const validateApplogDesc = (rule, value, callback) => {
      if (!isEmpty(value) && value.length > 4000) {
        callback(new Error(msgUtil.getStringLengthValidationMsgData(4000)));
      } else {
        callback();
      }
    };
    return {
      patternFlag: true,
      logTypeList: [
        { label: '텍스트', value: 'T' },
        { label: '바이너리', value: 'B' },
        { label: 'MySql Load', value: 'ML' },
      ],
      deleteTimeList: [
        { label: '일간', value: 'D' },
        { label: '주간', value: 'W' },
        { label: '월간', value: 'M' },
        { label: '연간', value: 'Y' },

      ],
      rules: {
        applogId: [
          { required: true, validator: validateApplogId, trigger: 'blur' },
        ],
        applogDir: [
          { validator: validateApplogDir, trigger: 'blur' },
        ],
        applogFile: [
          { validator: validateApplogFile, trigger: 'blur' },
        ],
        applogPatternFile: [
          { validator: validatePatternFile, trigger: 'blur' },
        ],
        applogDesc: [
          { validator: validateApplogDesc, trigger: 'blur' },
        ],
      },

    };
  },
  methods: {
    /**
     * 패턴 bool 값 설정
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectPattern(data) {
      this.formData.patternFlag = data;
      if (data === 'N') {
        this.patternFlag = true;
      } else {
        this.patternFlag = false;
      }
    },
    /**
     * 삭제 여부 체크 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    checkDelFlag() {
      return (this.formData.applogRawDelFlag === '1');
    },
    /**
     * 삭제주기 체크시 작동
     * @author leesy918
     * @return {[type]} [description]
     */
    changeDelFlag() {
      if (!this.checkDelFlag()) {
        this.formData.applogRawDelFlag = '0';
      } else {
        this.formData.applogRawDelFlag = '1';
        this.formData.applogRawDelInteval = 'D';
      }
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/component/ApplogBasicSetting.vue